import { render, staticRenderFns } from "./PageHotel.vue?vue&type=template&id=69683fd6&"
import script from "./PageHotel.vue?vue&type=script&lang=js&"
export * from "./PageHotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69683fd6')) {
      api.createRecord('69683fd6', component.options)
    } else {
      api.reload('69683fd6', component.options)
    }
    module.hot.accept("./PageHotel.vue?vue&type=template&id=69683fd6&", function () {
      api.rerender('69683fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hotel/PageHotel.vue"
export default component.exports